import { gqlSend } from '../store/gql/send'
import { GET_MINIMUM } from '../store/gql/minimum'


export const appFetchMinimumAPI = async () => {
  const variables = {
    key: 'hrms_setting_leave_min_duration',
  }

  return await gqlSend({
    query: GET_MINIMUM,
    req: variables,
  })
}
